import { render, staticRenderFns } from "./SkillsTable.vue?vue&type=template&id=c0e04a0c&scoped=true&"
import script from "./SkillsTable.vue?vue&type=script&lang=js&"
export * from "./SkillsTable.vue?vue&type=script&lang=js&"
import style0 from "./SkillsTable.vue?vue&type=style&index=0&id=c0e04a0c&scoped=true&lang=css&"
import style1 from "./SkillsTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e04a0c",
  null
  
)

export default component.exports